export default __webpack_public_path__ + "static/media/dashboard-collapse-active.77a472be.svg";